import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_Verdict } from './TimeFormVerdict.messages.json';
import styles from './TimeFormVerdict.scss';
import TimeFormLogo from './timeform.svg';

export const TimeFormVerdict = () => (
  <div className={styles.timeform}>
    <TimeFormLogo />
    <span className={styles.timeformVerdict}>
      <Translation {...TXTWCL_Verdict} />
    </span>
  </div>
);

export default TimeFormVerdict;
